export default __webpack_public_path__ + "static/media/keyimg.3303a515.jpg";